import React from 'react';
import { X } from 'lucide-react';

interface PhotoPreviewProps {
  photos: { url: string; file: File }[];
  onRemove: (index: number) => void;
}

export function PhotoPreview({ photos, onRemove }: PhotoPreviewProps) {
  if (photos.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
      {photos.map((photo, index) => (
        <div key={index} className="relative aspect-square">
          <img
            src={photo.url}
            alt={`Preview ${index + 1}`}
            className="w-full h-full object-cover rounded-lg"
          />
          <button
            onClick={() => onRemove(index)}
            className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}